import "core-js/modules/es7.array.includes";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { buildUniqueClassName, buildUniqueIdName } from '~/helpers/seo-helpers';
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/cercle-multicolor-vide.svg';
import '~/node_modules/@web/shared-digital-library/icons/svg-utilities/checkbox-unchecked.svg';
import '~/node_modules/@web/shared-digital-library/icons/svg-utilities/checkbox-checked.svg';
var MULTICOLOR_FACET_KEYS = ['n293bc353ebac183d8fae449017e1492f9cd9046', 'Multicolore'];
export default {
  name: 'CategoryFacetItem',
  props: {
    circle: {
      type: Boolean,
      required: true
    },
    selected: {
      type: Boolean,
      required: true
    },
    facet: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      buildUniqueClassName: buildUniqueClassName,
      buildUniqueIdName: buildUniqueIdName,
      colors: {
        default: '',
        gray: '#b5bdc4',
        kraft: '#c4a181',
        dark: '#3c3c3b',
        white: '#ffffff'
      }
    };
  },
  computed: {
    icon: function icon() {
      if (this.isMultiColor) return 'cercle-multicolor-vide';
      var icons = this.circle ? ['', ''] : ['checkbox-checked', 'checkbox-unchecked'];
      return this.selected ? icons[0] : icons[1];
    },
    size: function size() {
      return '16';
    },
    color: function color() {
      return this.circle ? this.colors.kraft : this.colors.default;
    },
    colorStyle: function colorStyle() {
      return {
        background: this.isMultiColor ? '#ffffff' : "#".concat(this.facet.hex_code),
        border: this.isWhite ? '1px solid #d7d7d7' : ''
      };
    },
    selectedColorStyle: function selectedColorStyle() {
      var tagColor = this.isWhite || this.isMultiColor ? '#9b9b9b' : "#".concat(this.facet.hex_code);
      return {
        '--tag-color': tagColor
      };
    },
    iconColorStyle: function iconColorStyle() {
      return this.selected ? _objectSpread({}, this.colorStyle, this.selectedColorStyle) : this.colorStyle;
    },
    isWhite: function isWhite() {
      return this.facet.hex_code === 'ffffff' || this.facet.key === 'Blanc';
    },
    isMultiColor: function isMultiColor() {
      return MULTICOLOR_FACET_KEYS.includes(this.facet.key);
    }
  }
};